import { render, staticRenderFns } from "./DynamicAttributeConfigurationVisibility.vue?vue&type=template&id=fdede806&"
import script from "./DynamicAttributeConfigurationVisibility.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeConfigurationVisibility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports